export class Reg {
axaDOB: string;
newEmail: string;
policyInd: string;
policyNum: string;
axassn: string;
ssnPasteEvent: string;
sessionId: string;
autoRegValid: boolean;
isCes: boolean;
caseId: string;
utm_source: string;
utm_medium: string;
utm_campaign: string;
utm_content: string;
}
